import Vue from 'vue'
import { baseURL } from '../config'
// 获取购物车详情
export const getCartList = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 购物车总数
export const cartCount = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 删除购物车
export const delItem = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 修改商品数量
export const changeNum = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 备注
export const beikao = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
//--------------------------------------------------------------------------------
// 购物车-生成订单预览(未保存到数据库的订单) 
export const newOrder = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 临时保存 /正式保存
export const sendOrder = data => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=sendOrder", data)
// 修改订单提交
export const updateOrder = data => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=updateOrder", data)
// 商品库-添加
export const addCommodity = (token, data) => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=addCommodity&token=" + token, data)

// 余额查询
export const balanceTotal = data => Vue.prototype.getAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=balanceTotal&token=" + localStorage.getItem('token'), data)

// 上传发货附件文件
export const updateDeliveryFile = data => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=updateDeliveryFile&token=" + localStorage.getItem('token'), data)